"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mutateKeys_1 = require("./mutateKeys");
exports.PREFIX_DELIMITER = '.';
function prefixLayer(prefix, delimiter) {
    if (delimiter === void 0) { delimiter = exports.PREFIX_DELIMITER; }
    var prefixKey = prefix + delimiter;
    return mutateKeys_1.mutateKeys(function (key) { return prefixKey + key; }, function (key) { return (key.startsWith(prefixKey) ? key.slice(prefixKey.length) : null); });
}
exports.prefixLayer = prefixLayer;
//# sourceMappingURL=prefixLayer.js.map